import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from '../bootstrap-modal';
import filter from 'lodash/filter';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';


const LocationBody = ({ metros, clickMetro, toggleModal }) => {
  const activeMetros = filter(metros, { active: true });
  const continents = groupBy(activeMetros, (metro) => {
    if ('US' === metro.country) {
      return 'United States';
    }
    if ('CA' === metro.country) {
      return 'Canada';
    }
    return 'Europe';
  });
  return (
    <div className="container-fluid" style={{ paddingBottom: '24px' }}>
      {
        map(continents, (continent, key) => {
          return (
            <div style={{ marginTop: '24px' }} key={key} className="row">
              <div className="col-xs-12">
                <h5>{key}</h5>
                <hr />
              </div>
              {
                map(sortBy(continent, 'name'), (metro, i) => {
                  const name = metro.name;
                  return (
                    <div key={`${continent}-${i}`} className="col-xs-6 col-sm-4">
                      <button
                        style={{ paddingLeft: 0 }}
                        className="btn btn-link remove-click-styling"
                        onClick={(e) => { clickMetro(e, toggleModal); }}
                        data-value={metro.nickname}
                      >
                        {name}
                      </button>
                    </div>
                  );
                })
              }
            </div>
          );
        })
      }
    </div>
  );
};

export class LocationModal extends React.Component {
  render () {
    const { showModal, toggleModal, clickMetro, metros } = this.props;
    return (
      <BootstrapModal
        showModal={showModal}
        modalSize="md-size"
        modalClass="activity-modal"
        onClose={toggleModal}
        header={ <h3>Peerspace Locations</h3> }
        body={
          <LocationBody
            metros={metros}
            clickMetro={clickMetro}
            toggleModal={toggleModal}
          />
        }
      />
    );
  }
}

LocationModal.propTypes = {
  metros: PropTypes.array.isRequired,
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  clickMetro: PropTypes.func
};

LocationBody.propTypes = {
  metros: PropTypes.array,
  clickMetro: PropTypes.func,
  toggleModal: PropTypes.func
};
